<div class="relative">
    <button (click)="toggleDropdown()" class="flex items-center space-x-2 px-3 py-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-800 border border-gray-200 dark:border-slate-700">
        <i class="fas fa-globe text-sm"></i>
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ selectedLang?.languageCode || 'EN' }}</span>
        <i class="fas fa-chevron-down text-xs"></i>
    </button>

    <div [class.hidden]="!isDropdownOpen" class="dropdown-menu-btn absolute right-0 mt-2 w-48 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-gray-200 dark:border-slate-700 py-2 z-50">
        @for (lang of languages(); track lang.languageId) {
            <a href="#" (click)="$event.preventDefault(); changeLang(lang.locale)" [class]="selectedLang?.locale === lang.locale ? 'flex items-center px-4 py-2 text-sm text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 font-medium' : 'flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700'">
                <span>{{ lang.languageName || lang.languageCode }}</span>
                @if (selectedLang?.locale === lang.locale) {
                    <i class="fas fa-check ml-auto"></i>
                }
            </a>
        }
    </div>
</div>